import { useRef } from "react";
import { gsap, prefersReducedMotion } from "@/lib/gsapSetup";

/**
 * Magnetic wrapper — the child is pulled toward the cursor on hover.
 * Renders a <button> or <a> depending on props.
 */
export default function MagneticButton({
  as = "button",
  children,
  className = "",
  strength = 0.4,
  onClick,
  href,
  ...rest
}) {
  const ref = useRef(null);
  const Tag = as;

  const handleMove = (e) => {
    if (prefersReducedMotion()) return;
    const el = ref.current;
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left - rect.width / 2) * strength;
    const y = (e.clientY - rect.top - rect.height / 2) * strength;
    gsap.to(el, { x, y, duration: 0.5, ease: "power3.out" });
  };

  const handleLeave = () => {
    if (prefersReducedMotion()) {
      gsap.set(ref.current, { x: 0, y: 0 });
      return;
    }
    gsap.to(ref.current, { x: 0, y: 0, duration: 0.6, ease: "elastic.out(1, 0.4)" });
  };

  return (
    <Tag
      ref={ref}
      href={href}
      onClick={onClick}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      className={className}
      data-cursor="hover"
      {...rest}
    >
      {children}
    </Tag>
  );
}
